export default "/institutions/digio.svg";